import { createRoot } from "react-dom/client";
import "./app/layout/styles.css";
import 'react-toastify/dist/ReactToastify.css';
import App from "./app/layout/App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

export const router = createBrowserRouter([{ path: "*", element: <App /> }]);
const container = document.getElementById("root");
const root = createRoot(container as HTMLElement);

root.render(<RouterProvider router={router} />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
